export default __webpack_public_path__ + "static/mosaic-dont-light-f2309c2090817d7dcf51fcff9d7e3f5f7e62a2e5afc37b9d731caa3665a3ea27.png";